import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import _ from 'lodash';

interface CheckBoxProps {
  checked: boolean;
  onCheck: () => void;
  selectAll?: boolean;
  disabled?: boolean;
  className?: any;
  style?: any;
  label?: string;
  id?: string;
  title?: string;
  ref?: any;
  labelClassName?: string;
}

const CheckBox = (props: CheckBoxProps) => {
  const { t } = useTranslation('common');

  const fnCallback = () => {
    if (!props.disabled) {
      props.onCheck();
    }
  };

  const keyDown = (event: any) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      //Enter key or spacebar
      fnCallback();
    }
  };

  const getTitle = () => (props.label ? props.label : defaultTitle);
  const defaultTitle = props.selectAll ? t('blazeTable.selectAll') : t('blazeTable.selectOne');
  const title = props.title ? props.title : getTitle();

  return (
    <div
      className={clsx('custom-control custom-checkbox custom-control-inline', props.className)}
      style={props.style ? props.style : undefined}
    >
      <input
        ref={props.ref}
        id={props.id ? props.id : undefined}
        className="custom-control-input"
        type="checkbox"
        checked={props.checked}
        onChange={() => _.noop()}
        onKeyDown={e => {
          keyDown(e);
        }}
        disabled={props.disabled}
      />
      <label
        title={title}
        className={clsx('custom-control-label cursor-pointer', props.labelClassName ? props.labelClassName : undefined)}
        onClick={fnCallback}
      >
        {props.label ? props.label : undefined}
      </label>
    </div>
  );
};

export default CheckBox;
